// extracted by mini-css-extract-plugin
export default {"tenantLogoContainer":"sidebar_tenantLogoContainer__vZhmj","logo":"sidebar_logo__r7Sn6","sidebarMenu":"sidebar_sidebarMenu__dwJ9N","menuItem":"sidebar_menuItem__h2Sw9"};